export const formatCurrency = (value: number, weekly = false): string => {
    if (!value) {
        value = 0;
    }

    if (weekly) {
        value = (value * 12) / 52.143; // 12 months in a year, 52.143 weeks in a year
    }

    const response = Math.abs(value).toLocaleString('en-GB', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trailingZeroDisplay: 'stripIfInteger',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });

    return response;
};
